// Load Styles
import '../scss/main.scss';

// Load Bootstrap init
import $ from "jquery";
import * as bootstrap from "bootstrap";
import {initBootstrap} from "./bootstrap.js";
import { io } from 'socket.io-client'
const host = `${process.env.HOST}`
const socket = io(host, {
  withCredentials: true,
  autoConnect: true,
  reconnection: true
})
window.socket = socket
window.socket.on('connect', (...args) => {
  console.log('connect', args)
})
window.socket.on('msg', (res) => {
  console.log('msg', res)
  if (res.doc_id) {
    initDocList()
    for (let i = 0; i < 2; i++) {
      setTimeout(function() {
        document.getElementById('eventAudio').play()
      }, i * 1000)
    }
  }
})

var alertTime;
var fixedAlert = function (text, type) {
    $('#alert').html('<div class="alert alert-' + (type || 'success') + '">' + text + '</div>')
    if (alertTime) {
      clearTimeout(alertTime);
    }
    alertTime = setTimeout(function () {
      $('#alert').html('');
    }, 1200);
}

// Loading bootstrap with optional features
initBootstrap({
  tooltip: true,
  popover: true,
  toasts: true,
});

// Your app code
// console.log(`Hello ${process.env.HELLO}`);

const ajax = function(data){
  data.traditional = false,
  data.xhrFields = {
      withCredentials: true
  }
  return $.ajax(data).then(function(res){
    if(res.code === 4005){
      $('.container').html('<h3 style="padding: 30px; text-align: center">'+ res.msg+'</h3>')
    }
    return res;
  })
}


var timestampToDate = function (timestamp) {
  var date = new Date(timestamp);
  var year = date.getFullYear();
  var month = ('0' + (date.getMonth() + 1)).slice(-2);
  var day = ('0' + date.getDate()).slice(-2);
  var hour = ('0' + date.getHours()).slice(-2);
  var minute = ('0' + date.getMinutes()).slice(-2);
  var second = ('0' + date.getSeconds()).slice(-2);
  return year + '年' + month + '月' + day + '日';
}
var timestampToDateTime = function (timestamp) {
  var date = new Date(timestamp);
  var year = date.getFullYear();
  var month = ('0' + (date.getMonth() + 1)).slice(-2);
  var day = ('0' + date.getDate()).slice(-2);
  var hour = ('0' + date.getHours()).slice(-2);
  var minute = ('0' + date.getMinutes()).slice(-2);
  var second = ('0' + date.getSeconds()).slice(-2);
  return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
}

var doc_status = {
  0: {"name":"等待处理"},
  1: {"name":"成功"},
  2: {"name":"失败"}
}
var doc_reason = {
  6: {"name":"无电子版"},
  7: {"name":"未找到"}
}

var docList = []
var drawDocList = function (rows){
  let map = {}
  for(let i in rows){
    let item = rows[i]
    let date = timestampToDate(item.created_at * 1000);
    item.date = timestampToDateTime(item.created_at * 1000);
    if(!map[date]){
      map[date] = []
    }
    map[date].push(item)
  }
  let docListPanel = $('#docList');
  docListPanel.html('')
  for(let i in map){
    let list = map[i];
    docListPanel.append('<h6>'+i+'</h6>')
    let tabEl = $('<table class="table table-bordered table-striped"><tr><th scope="col" style="text-align: center;">序号</th><th scope="col"  style="text-align: center;">文献需求列表</th><th scope="col"  style="text-align: center;">求助人</th><th scope="col"  style="text-align: center;">状态</th><th scope="col"  style="text-align: center;">下载链接</th></tr></table>')
    docListPanel.append(tabEl)

    let statusTextMap = {
      0: '待处理',
      1: '成功',
      2: '未找到',
      3: '无法下载',
      4: '无电子版',
      5: '信息不完整，请补足后重发',
      6: '信息不准确，请核实后重发',
      7: '未知原因'
    }
    for(let j in list){
      let item = list[j]
      let statusText = statusTextMap[item.status]
      let btnEl = ''
      if(item.status === 0){
        btnEl = '<button type="button" class="btn btn-secondary btn-sm del-btn" data-id="'+item.id+'" data-text="'+item.text+'">删除</button>'
      }else if(item.status === 1){
        if(item.file){
          let fileArr = JSON.parse(item.file);
          for(let i in fileArr){
            btnEl += '<p><a target="_blank" href="'+(host + '/'+ fileArr[i])+'" type="button" class="btn btn-primary btn-sm">文件'+(parseInt(i)+1)+'</a></p>'
          }
        }
      } 
      
      let username = ''
      if(item.user){
        username = item.user.username
      }else{
        username = '匿名用户('+item.ip+')'
      }

      tabEl.append('<tr id="doc_'+item.id+'"><th  style="width: 130px;">'+item.no+'</th><td style="width: 560px;">'+item.text+'</td>'+
      '<td style="width: 100px;"><div style="width: 100px;word-wrap:break-word;">'+(username)+'<div></td>'+
      '<td style="width: 90px;">'+statusText+'</td><td>'+btnEl+'</td></tr>')
    }
  }
}

var docListData = {page: 1, limit: 8, type: 1}

// 生成分页器链接
function generatePaginationLink(page) {
  const li = document.createElement('li');
  li.classList.add('page-item');
  const a = document.createElement('a');
  a.classList.add('page-link');
  a.href = '#';
  a.textContent = page;
  a.addEventListener('click', function(e) {
    e.preventDefault();
    docListData.page = page
    initDocList()
  });
  li.appendChild(a);
  return li;
}

// 更新分页器
function updatePagination(totalRecords) {
  // 每页显示的记录数
  let recordsPerPage = docListData.limit;
  // 总页数
  let totalPages = Math.ceil(totalRecords / recordsPerPage);
  // 当前页
  let currentPage = docListData.page;
  // 获取分页器元素
  let pagination = document.getElementById('pagination');
  let paginationTotal = document.getElementById('pagination-total');

  // 清空分页器
  pagination.innerHTML = '';
  paginationTotal.innerHTML = '';
  if(!parseInt(totalRecords)){
    paginationTotal.innerHTML = '共 0 个需求';
    return;
  }

  // 添加“Previous”链接
  const previousLi = document.createElement('li');
  previousLi.classList.add('page-item');
  if (currentPage === 1) {
    previousLi.classList.add('disabled');
  }
  const previousLink = document.createElement('a');
  previousLink.classList.add('page-link');
  previousLink.href = '#';
  previousLink.textContent = '上一页';
  previousLink.addEventListener('click', function(e) {
    e.preventDefault();
    if (currentPage > 1) {
      currentPage--;
      docListData.page = currentPage
      initDocList()
    }
  });
  previousLi.appendChild(previousLink);
  pagination.appendChild(previousLi);

  // 添加页码链接
  for (let i = 1; i <= totalPages; i++) {
    
    const li = generatePaginationLink(i);
    if (i === currentPage) {
      li.classList.add('active');
      li.setAttribute('aria-current', 'page');
    }
    pagination.appendChild(li);
  }

  // 添加“Next”链接
  const nextLi = document.createElement('li');
  nextLi.classList.add('page-item');
  if (currentPage === totalPages) {
    nextLi.classList.add('disabled');
  }
  const nextLink = document.createElement('a');
  nextLink.classList.add('page-link');
  nextLink.href = '#';
  nextLink.textContent = '下一页';
  nextLink.addEventListener('click', function(e) {
    e.preventDefault();
    if (currentPage < totalPages) {
      currentPage++;
      docListData.page = currentPage
      initDocList()
    }
  });
  nextLi.appendChild(nextLink);
  pagination.appendChild(nextLi);

  // 更新总数
  paginationTotal.textContent = '共 '+totalRecords + ' 个需求';
}

var initDocList = function(){
  docListData.offset = (docListData.page - 1) * docListData.limit, 
  ajax({
    type: "get",
    url: host+'/api/v1/doc/list',
    data: docListData,
    dataType: "json",
  }).then((res)=>{
    console.log('res', res)
    if(res.data && res.data.rows){
      drawDocList(res.data.rows)
      updatePagination(res.data.count);
    }
  })
}

$('.doc-type-tab').click(function(){
  docListData.type = $(this).attr('value')
  $('.doc-type-tab').removeClass('active')
  $(this).addClass('active')
  docListData.page = 1;
  initDocList()
})


$(function(){
  initDocList()

  //提交需求
  $('#submitDoc').click(function(){
    console.log('text', $('#docText').val())
    ajax({
      type: 'POST',
      url: host+'/api/v1/doc/add',
      data: {
        text: $('#docText').val()
      },
      dataType: "json",
      success: function(response) {
        // 处理成功响应
        if(response.code === 0){
          fixedAlert(response.msg || '提交成功');
          $('#docText').val('')
          initDocList()
        }else{
          fixedAlert(response.msg || '提交失败', 'danger');
        }
      },
      error: function(xhr, status, error) {
        // 处理错误响应
        fixedAlert('提交失败', 'danger');
      }
    });
  })

  //获取用户信息
  ajax({
    type: "get",
    url: host+'/api/v1/user/info',
    dataType: "json",
  }).then((res)=>{
    console.log('res', res)
    if(res.code){
      $('#loginBtns').show()
    }else{
      $('#userNameText').html(res.data.username);
      $('#userInfoPanel').show()
    }
  })

  $('#logoutBtn').click(function(){
    ajax({
      type: 'GET',
      url: host+'/api/v1/user_auth/logout',
      success: function(response) {
        // 处理成功响应
        if(response.code === 0){
          fixedAlert(response.msg || '退出登录成功');
          location.reload()
        }else{
          fixedAlert(response.msg || '退出登录失败', 'danger');
        }
      },
      error: function(xhr, status, error) {
        // 处理错误响应
        fixedAlert('退出登录失败', 'danger');
      }
    });
  })

  const registerModal = new bootstrap.Modal('#registerModal', {
    keyboard: false
  })

  // 当“提交”按钮被点击时
  $('#registerSubmitBtn').click(function() {
    // 获取表单数据
    var formData = $('#registerForm').serialize();
    // 发送Ajax请求
    ajax({
      type: 'POST',
      url: host+'/api/v1/user_auth/register',
      data: formData,
      success: function(response) {
        // 处理成功响应
        if(response.code === 0){
          registerModal.hide();
          fixedAlert(response.msg || '注册成功');
        }else{
          fixedAlert(response.msg || '登录失败', 'danger');
        }
      },
      error: function(xhr, status, error) {
        // 处理错误响应
        fixedAlert('注册失败', 'danger');
      }
    });
  });

  // 当“登录”按钮被点击时
  $('#loginSubmitBtn').click(function() {
    // 获取表单数据
    var formData = $('#loginForm').serialize();
    // 发送Ajax请求
    ajax({
      type: 'POST',
      url: host+'/api/v1/user_auth/login',
      data: formData,
      success: function(response) {
        // 处理成功响应
        if(response.code === 0){
          registerModal.hide();
          fixedAlert(response.msg || '登录成功');
          location.reload()
        }else{
          fixedAlert(response.msg || '登录失败', 'danger');
        }
      },
      error: function(xhr, status, error) {
        // 处理错误响应
        fixedAlert('登录失败', 'danger');
      }
    });
  });

  const deleteModal = new bootstrap.Modal('#deleteModal', {
    keyboard: false
  })
  let id;
  $('#confirmDelBtn').click(function(){
    ajax({
      type: 'POST',
      url: host+'/api/v1/doc/del',
      data: {id: id},
      success: function(response) {
        // 处理成功响应
        if(response.code === 0){
          deleteModal.hide();
          fixedAlert(response.msg || '删除成功');
          $('#doc_'+id).remove()
        }else{
          fixedAlert(response.msg || '删除失败', 'danger');
        }
      },
      error: function(xhr, status, error) {
        // 处理错误响应
        fixedAlert('删除失败', 'danger');
      }
    });
  })
  $('body').on( 'click', '.del-btn', function(){
    id = $(this).attr('data-id')
    $('#delContentText').html($(this).attr('data-text')) 
    deleteModal.show()
  })

})